module.exports = __webpack_public_path__ + "img/skin0.f09b8a82.jpg";